<template>
    <div
        :class="vTooltipClasses"
        :style="{visibility: isShow ? 'visible': 'hidden' ,top: tooltip.top + 'px', left: tooltip.left + 'px' }"
        class="VTooltip"
    >
        <div class="arrow"></div>
        <div
            v-if="title.length"
            class="VTooltip-header"
            v-html="title"
        ></div>
        <div
            class="VTooltip-body"
            v-html="content"
        ></div>
    </div>
</template>

<script>
    export default {
        name: 'VTooltip',
        props: {
            theme: {
                type: String,
                default: 'default',
            },
            title: {
                type: String,
                default: '',
            },
            content: {
                type: [String, Array, Object],
                default: '',
            },
            direction: {
                type: String,
                default: 'bottom',
            },
            clickable: {
                type: Boolean,
                default: false,
            },
            offsets: {
                type: Object,
                default: () => {
                },
            },
            event: {
                default: () => {
                },
            },
            showDelay: {
                type: Number,
                default: 1000,
            },
        },
        data() {
            return {
                isShow: false,
                tooltip: {
                    top: 0,
                    left: 0,
                },
                count: 0,
                currentElement: '',
            };
        },
        computed: {
            vTooltipClasses() {
                let allClasses = [];
                allClasses.push(`VTooltipTheme-${this.theme.toLowerCase()}`);
                allClasses.push(`VTooltipDirection-${this.direction.toLowerCase()}`);
                if (this.clickable) {
                    allClasses.push('VTooltip_clickable');
                }
                return allClasses;
            },
        },
        watch: {
            event: {
                handler(event) {
                    if (event) {
                        const currentCount = this.count;
                        this.currentElement = event.target;
                        this.addMouseOutListener(this.currentElement);
                        this.addClickListener(this.currentElement);
                        this.addScrollListener();
                        setTimeout(() => {
                            if (this.currentElement) {
                                const isElementExistInDom = _.cloneDeep(document.body.contains(this.currentElement));
                                if (isElementExistInDom && currentCount === this.count) {
                                    this.isShow = true;
                                    if (this.direction.toLowerCase() === 'bottom') {
                                        this.setBottomCoordinats(this.currentElement);
                                    } else if (this.direction.toLowerCase() === 'right') {
                                        this.setRightCoordinats(this.currentElement);
                                    }
                                }
                            }
                        }, this.showDelay);
                    } else {
                        this.isShow = false;
                    }
                },
            },
        },
        methods: {
            addMouseOutListener(el) {
                const listener = () => {
                    if (el && !this.isCurrentNodeInVTooltip()) {
                        el.removeEventListener('mouseleave', listener, false);
                        this.clearListener();
                    } else if (this.isCurrentNodeInVTooltip()) {
                        this.addMouseOutListener(this.getCurrentNode());
                        this.addClickListener(this.getCurrentNode());
                    }
                };
                el.addEventListener('mouseleave', listener, false);
            },
            addClickListener(el) {
                const listener = () => {
                    if (el) {
                        el.removeEventListener('click', listener, false);
                        this.clearListener();
                    }
                };
                el.addEventListener('click', listener, false);
            },
            addScrollListener() {
                const listener = () => {
                    window.removeEventListener('scroll', listener, false);
                    this.clearListener();
                };
                window.addEventListener('scroll', listener, false);
            },
            clearListener() {
                this.isShow = false;
                this.count++;
                this.currentElement = '';
            },
            setBottomCoordinats(el) {
                const tooltipWidth = this.$el.clientWidth;
                this.tooltip.top = el.getBoundingClientRect().bottom + el.getBoundingClientRect().height +
                    this.offsets.top;
                this.tooltip.left = el.getBoundingClientRect().left + ((el.getBoundingClientRect().width -
                    tooltipWidth) / 2) + this.offsets.left;
            },
            setRightCoordinats(el) {
                const tooltipHeight = this.$el.clientHeight;
                this.tooltip.top = el.getBoundingClientRect().top + (el.getBoundingClientRect().height / 2) - (tooltipHeight / 2) + this.offsets.top;
                this.tooltip.left = el.getBoundingClientRect().left + el.getBoundingClientRect().width + 10 + this.offsets.left;
            },
            getCurrentNode() {
                const allNodes = document.querySelectorAll(':hover');
                return allNodes[allNodes.length - 1];
            },
            isCurrentNodeInVTooltip() {
                const tooltipEl = document.querySelector('.VTooltip');
                const isTooltipContainsCurrentNode = tooltipEl.contains(this.getCurrentNode());
                return isTooltipContainsCurrentNode;
            },
        },
    };
</script>

<style lang="scss">
    .VTooltip {
        top: 0;
        left: 0;
        border-radius: 2px;
        font-size: 11px;
        font-family: 'Open Sans', Arial, Helvetica, sans-serif, sans-serif;
        color: #5a5b71;
        opacity: 1;
        position: fixed;
        max-width: 500px;
        padding: 1px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: start;
        text-decoration: none;
        text-shadow: none;
        text-transform: none;
        letter-spacing: normal;
        word-break: normal;
        word-spacing: normal;
        white-space: normal;
        background-color: #fff;
        background-clip: padding-box;
        box-shadow: 0 2px 6px 0 rgba(174, 191, 241, 1);
        line-break: auto;
        transition: opacity .15s linear;
        /*pointer-events: none;*/
        z-index: 1000;
        pointer-events: none;
        filter: drop-shadow(rgba(174, 191, 241, 1) 0px 0px 1px);
        
        &_clickable {
            pointer-events: all;
            
            .VTooltip-body {
                pointer-events: all;
            }
        }
        
        hr {
            margin-top: 5px !important;
            margin-bottom: 5px !important;
        }
        
        &-header {
            font-size: 11px;
            font-weight: 600;
            padding: 8px 14px;
            margin: 0;
            border-radius: 5px 5px 0 0;
            word-wrap: break-word;
        }
        
        &-body {
            text-align: start;
            text-shadow: none;
            text-transform: none;
            letter-spacing: normal;
            word-break: normal;
            word-spacing: normal;
            white-space: normal;
            pointer-events: none;
            padding: 9px 14px;
            border-radius: 2px;
            font-style: normal;
            font-weight: 400;
            line-height: 1.42857143;
            word-wrap: break-word;
        }
        
        &-content {
            &__column {
                padding-right: 30px;
            }
        }
        
        .arrow {
            position: absolute;
            display: block;
            width: 0;
            height: 0;
            
            &:after {
                content: " ";
                border-color: transparent;
                border-width: 10px;
                border-left-width: 0;
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                border-style: solid;
                box-sizing: border-box;
                
            }
        }
        
        &Direction {
            
            &-bottom {
                .arrow {
                    top: -16px;
                    left: 50%;
                    margin-left: -6px;
                    transform: rotate(90deg);
                    
                    &:after {
                        top: -10px;
                    }
                }
            }
            
            &-right {
                .arrow {
                    top: 50%;
                    left: 0;
                    margin-left: -11px;
                    transform: translateY(-50%);
                    
                    &:after {
                        top: -10px;
                    }
                }
            }
            
        }
        
        &Theme {
            &-default {
                .arrow {
                    border-color: transparent;
                    border-right-color: rgba(0, 0, 0, .25);
                    border-right-color: #fff;
                    border-width: 11px;
                    border-left-width: 0;
                    border-style: solid;
                    
                    &:after {
                        border-right-color: #fff;
                    }
                }
                
                .VTooltip {
                    &-header {
                        color: #5a5b71;
                        background-color: #f7f7f7;
                        border-bottom: 1px solid #ebebeb;
                    }
                    
                    &-body {
                        font-size: 11px;
                        color: #5a5b71;
                    }
                }
            }
            
        }
    }

</style>
